import FilterList from 'material-ui/svg-icons/content/filter-list';
import {FilterMenu} from './index';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import React, {PropTypes} from 'react';

export default function Filter({filters, onFilterRequest}) {
  const menuAnchorOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
  };

  const menuTargetOrigin = {
    vertical: 'top',
    horizontal: 'right',
  };

  return (
    <div>
      <IconMenu
        iconButtonElement={<IconButton><FilterList /></IconButton>}
        value={''}
        anchorOrigin={menuAnchorOrigin}
        targetOrigin={menuTargetOrigin}>
        <FilterMenu filters={filters} handleCheck={onFilterRequest} />
      </IconMenu>
    </div>
  );
}

Filter.propTypes = {
  filters: PropTypes.object.isRequired,
  onFilterRequest: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/shared/components/Filter.js